import { Col, Row } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import SelectField from '../../../../../components/fields/SelectField';
import FormFields from '../../../../../themes/admin/Fields/FormFields';
import useFinanceProductOptions from '../../shared/useFinanceProductOptions';
import { type FinanceProductFormValues } from '../index';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const AverageMileage = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);
    const { values } = useFormikContext<FinanceProductFormValues>();
    const { averageMileageUnitOption } = useFinanceProductOptions();
    const {
        residualValue: { averageMileage },
    } = values;

    const min = averageMileage?.min || 0;
    const max = averageMileage?.max || 0;

    return (
        <Row gutter={[16, 16]}>
            <>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.minMileage', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="residualValue.averageMileage.min"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.maxMileage', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="residualValue.averageMileage.max"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.mileageStep', { returnObjects: true })}
                        disabled={min >= max || disabled}
                        min={0}
                        name="residualValue.averageMileage.step"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.defaultMileage', {
                            returnObjects: true,
                        })}
                        addonAfter={
                            <SelectField
                                itemProps={{ noStyle: true }}
                                name="residualValue.averageMileage.defaultUnit"
                                options={averageMileageUnitOption}
                            />
                        }
                        disabled={disabled}
                        min={0}
                        name="residualValue.averageMileage.default"
                        required
                    />
                </Col>
            </>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.show', { returnObjects: true })}
                    disabled={disabled}
                    name="residualValue.averageMileage.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.editable', { returnObjects: true })}
                    disabled={!averageMileage?.isViewable || disabled}
                    name="residualValue.averageMileage.isEditable"
                />
            </Col>
        </Row>
    );
};

export default AverageMileage;
